<!-- eslint-disable -->
<template>
  <div class="crm-toolbar">
    <!-- Main toolbar row -->
    <div class="crm-toolbar__row">
      <!-- Search input -->
      <div class="crm-toolbar__search">
        <div class="crm-toolbar__search-wrapper">
          <feather-icon icon="SearchIcon" size="16" class="crm-toolbar__search-icon" />
          <input
            type="text"
            class="crm-toolbar__search-input"
            placeholder="Search cards..."
            :value="searchQuery"
            @input="$emit('update:searchQuery', $event.target.value)"
          />
          <button
            v-if="searchQuery"
            class="crm-toolbar__search-clear"
            @click="$emit('update:searchQuery', '')"
          >
            <feather-icon icon="XIcon" size="14" />
          </button>
        </div>
      </div>

      <!-- Active filter chips -->
      <div class="crm-toolbar__chips">
        <span
          v-for="chip in activeFilterChips"
          :key="chip.key"
          class="crm-toolbar__chip"
        >
          <span class="crm-toolbar__chip-dot" :style="{ background: chip.color }"></span>
          <span class="crm-toolbar__chip-text">{{ chip.label }}</span>
          <button class="crm-toolbar__chip-close" @click="clearFilter(chip.key)">
            <feather-icon icon="XIcon" size="12" />
          </button>
        </span>
      </div>

      <!-- Action buttons -->
      <div class="crm-toolbar__actions">
        <!-- Filter toggle -->
        <button class="crm-toolbar__btn" @click="$emit('toggle-filter-panel')" title="Filters">
          <feather-icon icon="FilterIcon" size="16" />
          <span v-if="activeFilterCount > 0" class="crm-toolbar__btn-badge">{{ activeFilterCount }}</span>
        </button>

        <!-- Sort dropdown -->
        <div class="crm-toolbar__sort">
          <feather-icon icon="ArrowUpDownIcon" size="14" class="crm-toolbar__sort-icon" />
          <select
            class="crm-toolbar__sort-select"
            :value="currentSort"
            @change="handleSortChange($event.target.value)"
          >
            <option value="date">Date</option>
            <option value="value">Value</option>
            <option value="priority">Priority</option>
            <option value="title">A-Z</option>
          </select>
        </div>



        <!-- Export dropdown -->
        <div class="crm-toolbar__export" v-click-outside="closeExportMenu">
          <button class="crm-toolbar__btn" @click="showExportMenu = !showExportMenu" title="Export">
            <feather-icon icon="DownloadIcon" size="16" />
          </button>
          <transition name="crm-dropdown">
            <div v-if="showExportMenu" class="crm-toolbar__export-menu">
              <button class="crm-toolbar__export-item" @click="handleExport('csv')">
                <feather-icon icon="FileTextIcon" size="14" />
                <span>Export CSV</span>
              </button>
              <button class="crm-toolbar__export-item" @click="handleExport('json')">
                <feather-icon icon="CodeIcon" size="14" />
                <span>Export JSON</span>
              </button>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- Bulk action bar -->
    <transition name="crm-slide-down">
      <div v-if="selectedCount > 0" class="crm-toolbar__bulk">
        <div class="crm-toolbar__bulk-info">
          <feather-icon icon="CheckSquareIcon" size="16" />
          <span>{{ selectedCount }} item{{ selectedCount > 1 ? 's' : '' }} selected</span>
        </div>

        <div class="crm-toolbar__bulk-actions">
          <!-- Move to -->
          <div class="crm-toolbar__bulk-dropdown" v-click-outside="closeMoveMenu">
            <button class="crm-toolbar__bulk-btn" @click="showMoveMenu = !showMoveMenu">
              <feather-icon icon="CornerRightDownIcon" size="14" />
              <span>Move to...</span>
            </button>
            <transition name="crm-dropdown">
              <div v-if="showMoveMenu" class="crm-toolbar__bulk-menu">
                <button
                  v-for="stage in stages"
                  :key="stage.id"
                  class="crm-toolbar__bulk-menu-item"
                  @click="handleBulkAction('move', stage.id)"
                >
                  <span class="crm-toolbar__bulk-menu-dot" :style="{ background: stage.color }"></span>
                  {{ stage.name }}
                </button>
              </div>
            </transition>
          </div>

          <!-- Assign to -->
          <div class="crm-toolbar__bulk-dropdown" v-click-outside="closeAssignMenu">
            <button class="crm-toolbar__bulk-btn" @click="showAssignMenu = !showAssignMenu">
              <feather-icon icon="UserPlusIcon" size="14" />
              <span>Assign to...</span>
            </button>
            <transition name="crm-dropdown">
              <div v-if="showAssignMenu" class="crm-toolbar__bulk-menu">
                <button
                  v-for="owner in uniqueOwners"
                  :key="owner"
                  class="crm-toolbar__bulk-menu-item"
                  @click="handleBulkAction('assign', owner)"
                >
                  <span class="crm-toolbar__bulk-menu-avatar">{{ owner.charAt(0) }}</span>
                  {{ owner }}
                </button>
              </div>
            </transition>
          </div>

          <!-- Add Label -->
          <div class="crm-toolbar__bulk-dropdown" v-click-outside="closeLabelMenu">
            <button class="crm-toolbar__bulk-btn" @click="showLabelMenu = !showLabelMenu">
              <feather-icon icon="TagIcon" size="14" />
              <span>Add Label</span>
            </button>
            <transition name="crm-dropdown">
              <div v-if="showLabelMenu" class="crm-toolbar__bulk-menu">
                <button
                  v-for="label in availableLabels"
                  :key="label.name"
                  class="crm-toolbar__bulk-menu-item"
                  @click="handleBulkAction('add-label', label)"
                >
                  <span class="crm-toolbar__bulk-menu-dot" :style="{ background: label.color }"></span>
                  {{ label.name }}
                </button>
              </div>
            </transition>
          </div>

          <!-- Delete -->
          <button class="crm-toolbar__bulk-btn crm-toolbar__bulk-btn--danger" @click="handleBulkAction('delete')">
            <feather-icon icon="Trash2Icon" size="14" />
            <span>Delete</span>
          </button>

          <!-- Clear -->
          <button class="crm-toolbar__bulk-btn crm-toolbar__bulk-btn--ghost" @click="handleBulkAction('clear')">
            <feather-icon icon="XIcon" size="14" />
            <span>Clear</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'PipelineToolbar',

  props: {
    searchQuery: {
      type: String,
      default: '',
    },
    filters: {
      type: Object,
      required: true,
    },
    activePipeline: {
      type: String,
      required: true,
    },
    selectedCount: {
      type: Number,
      default: 0,
    },
    boardSettings: {
      type: Object,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      currentSort: this.boardSettings.defaultSort || 'date',
      showExportMenu: false,
      showMoveMenu: false,
      showAssignMenu: false,
      showLabelMenu: false,
    }
  },

  directives: {
    'click-outside': {
      bind(el, binding) {
        el.__clickOutside = (event) => {
          if (!el.contains(event.target)) {
            binding.value()
          }
        }
        document.addEventListener('click', el.__clickOutside)
      },
      unbind(el) {
        document.removeEventListener('click', el.__clickOutside)
      },
    },
  },

  computed: {
    activeFilterChips() {
      const chips = []
      const colorMap = {
        stages: '#6366f1',
        priorities: '#f59e0b',
        owners: '#10b981',
        labels: '#f43f5e',
      }

      if (this.filters.stages && this.filters.stages.length) {
        chips.push({
          key: 'stages',
          label: `Stage: ${this.filters.stages.length}`,
          color: colorMap.stages,
        })
      }
      if (this.filters.priorities && this.filters.priorities.length) {
        chips.push({
          key: 'priorities',
          label: `Priority: ${this.filters.priorities.join(', ')}`,
          color: colorMap.priorities,
        })
      }
      if (this.filters.owners && this.filters.owners.length) {
        chips.push({
          key: 'owners',
          label: `Owner: ${this.filters.owners.length}`,
          color: colorMap.owners,
        })
      }
      if (this.filters.labels && this.filters.labels.length) {
        chips.push({
          key: 'labels',
          label: `Labels: ${this.filters.labels.length}`,
          color: colorMap.labels,
        })
      }
      return chips
    },

    activeFilterCount() {
      let count = 0
      if (this.filters.stages && this.filters.stages.length) count++
      if (this.filters.priorities && this.filters.priorities.length) count++
      if (this.filters.owners && this.filters.owners.length) count++
      if (this.filters.labels && this.filters.labels.length) count++
      if (this.filters.dateRange && (this.filters.dateRange.from || this.filters.dateRange.to)) count++
      if (this.filters.hasChecklist !== null && this.filters.hasChecklist !== undefined) count++
      if (this.filters.hasAttachments !== null && this.filters.hasAttachments !== undefined) count++
      return count
    },

    uniqueOwners() {
      // Extract unique owners from stages or provide defaults
      return ['Mohammed', 'Khaled', 'Ahmed', 'Sara', 'Fatima']
    },

    availableLabels() {
      return [
        { name: 'Urgent', color: '#ef4444' },
        { name: 'Review', color: '#6366f1' },
        { name: 'Follow Up', color: '#f59e0b' },
        { name: 'VIP', color: '#10b981' },
        { name: 'Blocked', color: '#f43f5e' },
      ]
    },
  },

  methods: {
    clearFilter(key) {
      const value = key === 'dateRange' ? { from: null, to: null } : []
      this.$emit('filter-change', { key, value })
    },

    handleSortChange(sortKey) {
      this.currentSort = sortKey
      this.$emit('sort-change', sortKey)
    },

    handleExport(format) {
      this.showExportMenu = false
      this.$emit('export', format)
    },

    handleBulkAction(action, data) {
      this.showMoveMenu = false
      this.showAssignMenu = false
      this.showLabelMenu = false
      this.$emit('bulk-action', { action, data })
    },

    closeExportMenu() {
      this.showExportMenu = false
    },
    closeMoveMenu() {
      this.showMoveMenu = false
    },
    closeAssignMenu() {
      this.showAssignMenu = false
    },
    closeLabelMenu() {
      this.showLabelMenu = false
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #6366f1;
$primary-dark: #4f46e5;
$success: #10b981;
$warning: #f59e0b;
$danger: #f43f5e;
$slate-50: #f8fafc;
$slate-100: #f1f5f9;
$slate-200: #e2e8f0;
$slate-300: #cbd5e1;
$slate-400: #94a3b8;
$slate-500: #64748b;
$slate-600: #475569;
$slate-700: #334155;
$slate-900: #0f172a;

.crm-toolbar {
  background: #fff;
  border-bottom: 1px solid $slate-200;
  position: relative;
  z-index: 10;

  &__row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px;
    flex-wrap: wrap;
  }

  /* ── Search ── */
  &__search {
    flex-shrink: 0;
  }

  &__search-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 280px;
    background: $slate-50;
    border: 1px solid $slate-200;
    border-radius: 10px;
    transition: all 0.2s ease;

    &:focus-within {
      border-color: $primary;
      box-shadow: 0 0 0 3px rgba($primary, 0.1);
      background: #fff;
    }
  }

  &__search-icon {
    position: absolute;
    left: 12px;
    color: $slate-400;
    pointer-events: none;
  }

  &__search-input {
    width: 100%;
    padding: 8px 34px 8px 36px;
    border: none;
    background: transparent;
    font-size: 13px;
    color: $slate-700;
    outline: none;
    font-family: 'Outfit', 'Inter', sans-serif;

    &::placeholder {
      color: $slate-400;
    }
  }

  &__search-clear {
    position: absolute;
    right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: none;
    background: $slate-200;
    border-radius: 50%;
    color: $slate-500;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      background: $slate-300;
      color: $slate-700;
    }
  }

  /* ── Filter chips ── */
  &__chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    flex-wrap: wrap;
    min-width: 0;
  }

  &__chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px 4px 8px;
    background: $slate-50;
    border: 1px solid $slate-200;
    border-radius: 20px;
    font-size: 12px;
    color: $slate-600;
    white-space: nowrap;
    animation: crm-chip-in 0.2s ease;
  }

  &__chip-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__chip-text {
    font-weight: 500;
  }

  &__chip-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border: none;
    background: transparent;
    color: $slate-400;
    cursor: pointer;
    border-radius: 50%;
    padding: 0;
    transition: all 0.15s ease;

    &:hover {
      background: $slate-200;
      color: $slate-700;
    }
  }

  /* ── Action buttons ── */
  &__actions {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-shrink: 0;
  }

  &__btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 1px solid $slate-200;
    background: #fff;
    border-radius: 8px;
    color: $slate-500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: $slate-50;
      color: $slate-700;
      border-color: $slate-300;
    }
  }

  &__btn-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    background: $primary;
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ── Sort ── */
  &__sort {
    position: relative;
    display: flex;
    align-items: center;
  }

  &__sort-icon {
    position: absolute;
    left: 10px;
    color: $slate-400;
    pointer-events: none;
    z-index: 1;
  }

  &__sort-select {
    padding: 8px 12px 8px 30px;
    border: 1px solid $slate-200;
    border-radius: 8px;
    background: #fff;
    font-size: 13px;
    color: $slate-600;
    cursor: pointer;
    appearance: none;
    font-family: 'Outfit', 'Inter', sans-serif;
    outline: none;
    min-width: 100px;
    transition: all 0.2s ease;

    &:hover {
      border-color: $slate-300;
    }

    &:focus {
      border-color: $primary;
      box-shadow: 0 0 0 3px rgba($primary, 0.1);
    }
  }

  /* ── Density ── */
  &__density {
    display: flex;
    border: 1px solid $slate-200;
    border-radius: 8px;
    overflow: hidden;
  }

  &__density-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: none;
    background: #fff;
    color: $slate-400;
    cursor: pointer;
    transition: all 0.2s ease;

    &:first-child {
      border-right: 1px solid $slate-200;
    }

    &:hover {
      background: $slate-50;
      color: $slate-600;
    }

    &--active {
      background: $primary !important;
      color: #fff !important;
    }
  }

  /* ── Export ── */
  &__export {
    position: relative;
  }

  &__export-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    width: 170px;
    background: #fff;
    border: 1px solid $slate-200;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    z-index: 100;
  }

  &__export-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 14px;
    border: none;
    background: transparent;
    font-size: 13px;
    color: $slate-600;
    cursor: pointer;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: background 0.15s ease;

    &:hover {
      background: $slate-50;
      color: $slate-900;
    }
  }

  /* ── Bulk action bar ── */
  &__bulk {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 20px;
    background: linear-gradient(135deg, #eef2ff, #e0e7ff);
    border-top: 1px solid rgba($primary, 0.15);
  }

  &__bulk-info {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: $primary-dark;
    white-space: nowrap;
  }

  &__bulk-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  &__bulk-dropdown {
    position: relative;
  }

  &__bulk-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid rgba($primary, 0.2);
    background: #fff;
    border-radius: 7px;
    font-size: 12.5px;
    font-weight: 500;
    color: $slate-700;
    cursor: pointer;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      border-color: $primary;
      color: $primary;
      box-shadow: 0 2px 8px rgba($primary, 0.1);
    }

    &--danger {
      color: $danger;
      border-color: rgba($danger, 0.2);

      &:hover {
        background: rgba($danger, 0.05);
        border-color: $danger;
        color: $danger;
        box-shadow: 0 2px 8px rgba($danger, 0.1);
      }
    }

    &--ghost {
      border-color: transparent;
      background: transparent;
      color: $slate-500;

      &:hover {
        background: rgba(0, 0, 0, 0.04);
        color: $slate-700;
      }
    }
  }

  &__bulk-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    min-width: 180px;
    background: #fff;
    border: 1px solid $slate-200;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    overflow: hidden;
    z-index: 100;
    max-height: 240px;
    overflow-y: auto;
  }

  &__bulk-menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 9px 14px;
    border: none;
    background: transparent;
    font-size: 13px;
    color: $slate-600;
    cursor: pointer;
    font-family: 'Outfit', 'Inter', sans-serif;
    transition: background 0.15s ease;

    &:hover {
      background: $slate-50;
      color: $slate-900;
    }
  }

  &__bulk-menu-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  &__bulk-menu-avatar {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: $primary;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
}

/* ── Animations ── */
@keyframes crm-chip-in {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.crm-slide-down-enter-active,
.crm-slide-down-leave-active {
  transition: all 0.25s ease;
  max-height: 80px;
  overflow: hidden;
}

.crm-slide-down-enter,
.crm-slide-down-leave-to {
  max-height: 0;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  opacity: 0;
}

.crm-dropdown-enter-active,
.crm-dropdown-leave-active {
  transition: all 0.18s ease;
}

.crm-dropdown-enter,
.crm-dropdown-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
